import { render } from "./GeoMismatchModal.vue?vue&type=template&id=534beb7b&scoped=true"
import script from "./GeoMismatchModal.vue?vue&type=script&lang=js"
export * from "./GeoMismatchModal.vue?vue&type=script&lang=js"

import "./GeoMismatchModal.vue?vue&type=style&index=0&id=534beb7b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534beb7b"]])

export default __exports__